@for (item of sources?.picturesSources; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Documentazione fotografica {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.owner) {
        <div>
          <dt>Ente proprietario</dt>
          <dd>{{ item.owner }}</dd>
        </div>
      }
      @if (item?.code) {
        <div>
          <dt>Codice identificativo</dt>
          <dd>{{ item.code }}</dd>
        </div>
      }
    </dl>
  </section>
}

@for (item of sources?.documentSources; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Fonti e documenti {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.type?.definition) {
        <div>
          <dt>Tipo</dt>
          <dd>{{ item.type.definition }}</dd>
        </div>
      }
      @if (item?.author) {
        <div>
          <dt>Autore</dt>
          <dd>{{ item.author }}</dd>
        </div>
      }
      @if (item?.denomination) {
        <div>
          <dt>Denominazione</dt>
          <dd>{{ item.denomination }}</dd>
        </div>
      }
      @if (item?.date) {
        <div>
          <dt>Data</dt>
          <dd>{{ item.date }}</dd>
        </div>
      }
      @if (item?.paper) {
        <div>
          <dt>Foglio / carta</dt>
          <dd>{{ item.paper }}</dd>
        </div>
      }
      @if (item?.position) {
        <div>
          <dt>Posizione</dt>
          <dd>{{ item.position }}</dd>
        </div>
      }
      @if (item?.archiveName) {
        <div>
          <dt>Nome archivio</dt>
          <dd>{{ item.archiveName }}</dd>
        </div>
      }
    </dl>
  </section>
}

@for (item of sources?.bibliography; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Bibliografia {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.genre?.definition) {
        <div>
          <dt>Genere</dt>
          <dd>{{ item.genre.definition }}</dd>
        </div>
      }
      @if (item?.author) {
        <div>
          <dt>Autore</dt>
          <dd>{{ item.author }}</dd>
        </div>
      }
      @if (item?.year) {
        <div>
          <dt>Anno di edizione</dt>
          <dd>{{ item.year }}</dd>
        </div>
      }
      @if (item?.acronym) {
        <div>
          <dt>Sigla per citazione</dt>
          <dd>{{ item.acronym }}</dd>
        </div>
      }
      @if (item?.vPpNn) {
        <div>
          <dt>V. pp. nn.</dt>
          <dd>{{ item.vPpNn }}</dd>
        </div>
      }
      @if (item?.vTavvFigg) {
        <div>
          <dt>V. tavv. figg.</dt>
          <dd>{{ item.vTavvFigg }}</dd>
        </div>
      }
    </dl>
  </section>
}

@if (sources?.completeCitations?.length > 0) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Citazione completa</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Citazioni</dt>
        <dd>
          @for (item of sources.completeCitations; track item; let i = $index) {
            {{ item.completeCitation }}@if (i + 1 < sources.completeCitations.length) {; }
          }
        </dd>
      </div>
    </dl>
  </section>
}
